import { useDispatch } from '@ps/web-core-store';
import { mappers } from '@ps/web-poker-tile-mappers';
import { useActiveGamesUpdateSubscription } from '@ps/web-shared-generated-graphql/AG';
import { useEffect } from 'react';

const ActiveGamesSubscribe = () => {
  const { data } = useActiveGamesUpdateSubscription({
    errorPolicy: 'all'
  });
  const { activeGames } = useDispatch();
  const { mapActiveGames, getActiveGameIds } = mappers;

  useEffect(() => {
    if (!data?.activeGames) return;
    const { tournInvite, joined } = data.activeGames;

    if (tournInvite?.seatsAvailable) {
      activeGames.setTournamentInvite(tournInvite.tournamentId);
    } else {
      if (joined) {
        activeGames.add(mapActiveGames(data.activeGames));
      } else {
        activeGames.remove(getActiveGameIds(data.activeGames));
      }
    }
  }, [data, activeGames, mapActiveGames, getActiveGameIds]);

  return null;
};

export default ActiveGamesSubscribe;
